<template>
  <v-card elevation="2" shaped class="ma-1">
    <v-toolbar flat color="primary" dark>
      <v-toolbar-title>Paramètres du module Formulaire </v-toolbar-title>
    </v-toolbar>

    <Select
    :item="{name: 'Type de sauvegarde',value: '',liste: [{text:'Sur page formulaire de la table du module (form de vuex)',value:''},{text:'sur localStorage',value:'localstorage'},{text:'sur vuex avec clé personnalisée',value:'vuex'},{text:'sauvegarde indépendante (necessaite valeurs prédéfinis)',value:'inside'}],
    defaultprops:{ show: true}}"
    :change="(item,value,select) => { displays.params.typesave = value['value']; $emit('recepVal',displays); }"
    :valField="displays.params.typesave"
    />  

    <v-tabs align="start" background-color="blue lighten-5" v-model="tab">
          <v-tab> Champs à afficher </v-tab>
          <v-tab> Valeurs prédéfinis (hors sauvegarde sur page formulaire)</v-tab>
          <v-tab v-if="displays.params.typesave!='classic'"> Type de sauvegarde si front</v-tab>
          <v-tabs-items v-model="tab" class="pl-4">
            <v-tab-item>
              <SwitchC
              :item="{name:'Affichage sur une ligne',value:'online',defaultprops:{show:true}}" 
              :change="(item,model) => {displays.params.online = model; }"
              :valField="displays.params.online" />
              <v-row>
                <v-col class="ma-1">
                  <FieldSelectionEditor
                    :fields="allFields"
                    :value="displays.params.champs"
                    label="Champs à afficher dans le formulaire"
                    @change="changeFields"
                    @edit="editField"
                  />
                </v-col>
              </v-row>

            </v-tab-item>

          <v-tab-item>
            <SwitchC
            :item="{name:'Activer l\'enregistrement indépendant',value:'set',defaultprops:{show:true}}" 
            :change="(item,model) => {displays.params.dependencies.set = model; $emit('recepVal',displays); }"
            :valField="displays.params.dependencies.set" />

            <div v-if="displays.params.dependencies.set">
              <TextField 
              :item="{name:'nom du bouton d\'enregistrement',value:'',defaultprops:{show:true}}" 
              :keyup="(item,value) => {displays.params.dependencies.buttonname = value;  $emit('recepVal',displays); }"
              :valField="displays.params.dependencies.buttonname" />
              <TextField 
              :item="{name:'class duformulaire',value:'',defaultprops:{show:true}}" 
              :keyup="(item,value) => {displays.params.dependencies.formclass = value;  $emit('recepVal',displays); }"
              :valField="displays.params.dependencies.formclass" />

              <p>Recherchez les valeurs de vos champs via cette requete. Les AS doivent correspondre à la clé des champs (valeur de produits.nom = clé : produitsNom)</p>
              <p>(Valide hors sauvegarde sur page formulaire de la table du module)</p>
          <v-tabs align="start" background-color="blue lighten-5" v-model="tab2">
              <v-tab>Filtre </v-tab>
              <v-tab> Champs</v-tab>
              <v-tabs-items v-model="tab2" class="pl-4">
                <v-tab-item>
                  
                  <Filtre :page="page" :filtre="displays.params.dependencies.datas.filtre" :table="module.table" @recepVal="(data)=> {displays.params.dependencies.datas.filtre = data; $emit('recepVal',displays); }" />
                </v-tab-item>
                <v-tab-item>
                  
                  <Fields :page="page" :champs="displays.params.dependencies.datas.champs" :modalKey="modalKey" :filter="displays.params.dependencies.datas.filtre" :table="module.table" />
                </v-tab-item>
              </v-tabs-items>
          </v-tabs>

            </div>

          </v-tab-item>

          <v-tab-item v-if="displays.params.typesave!='classic'">

          <TextField 
            :item="{name:'Clé permettant la sauvegarde des informations',value:'',defaultprops:{show:true}}" 
            :keyup="(item,value) => {displays.params.paramsave.key = value;  $emit('recepVal',displays); }"
            :valField="displays.params.paramsave.key" />

          </v-tab-item>
          
          </v-tabs-items>
            </v-tabs>



  </v-card>
</template>



<script>
    import { admin } from '../mixins'; 
    import { openFieldEditor } from '@/components/engine/editField/navigation'
export default {
  name: "FormModule",
  props: ["module", "page",'modalKey'],

   mixins : [admin],

  components: {
    FieldSelectionEditor: () => import('../common/FieldSelectionEditor.vue'),
  },

  data: function () {
    return {
      tab : '',
      tab2 : '',
      allFields : [],
      displays: this.module.displays,
    };
  },

  methods: {
    editField(field) {
      if (field.create) {
        openFieldEditor({ id: field.id, onSaved: () => this.getFromAPI() })
      } else {
        openFieldEditor({ name: field.field, table: field.table, onSaved: () => this.getFromAPI() })
      }
    },

    changeFields(keys) {
      this.displays.params.champs = keys;
      this.$emit('recepVal',this.displays);
    },

    getFromAPI() {
      this.getListField({filter:{table:this.module.table}}).then((resp) => {
          this.allFields = resp;
        });
    },
  },

  mounted() {
    this.getFromAPI();
  },
};
</script>

